export default __webpack_public_path__ + "static/hed-section-1-img-a490557dc079264e9c48ee129b1c5e02.png";